'use client';

import { Switch } from "@headlessui/react";
import { jobListLayoutAtom } from "./atoms/jobListAtoms";
import { Tooltip } from "flowbite-react";
import { useAtom } from "jotai";
import { FaTable, FaList } from 'react-icons/fa6';

export default function JobListLayoutToggle() {
    const [jobListLayout, setJobListLayout] = useAtom(jobListLayoutAtom);

    return (
        <div className="flex flex-row items-center mr-2">
            <Tooltip content="List view">
                <FaList className={jobListLayout === 'list' ? 'text-black dark:text-white' : 'text-neutral-400'} />
            </Tooltip>
            <Switch
                checked={jobListLayout === 'wall'}
                name="searchLayoutToggle"
                onClick={() => { setJobListLayout((current) => current === 'list' ? 'wall' : 'list') }}
                className="mx-4 relative inline-flex h-2 w-8 items-center rounded-none ui-checked:bg-blue-400 ui-not-checked:bg-neutral-400 ui-not-checked:dark:bg-neutral-600">
                <span className="inline-block h-5 w-5 transform rounded-sm bg-neutral-500 dark:bg-neutral-400 transition ui-checked:translate-x-6 ui-not-checked:-translate-x-1" />
            </Switch>
            <Tooltip content="Gallery view">
                <FaTable className={jobListLayout === 'wall' ? 'text-black dark:text-white' : 'text-neutral-400'} />
            </Tooltip>
        </div>
    )
}